angular.module('impactx').provider('$config', function () {
    this.sourceURL = 'http://demo01.veenion.de/io6v/jax/ux';
    this.baseURL = '';
    this.searchInput = '';
    this.useSecureCookie = false;

    /**
     * contains all defined themes
     * @type {Array}
     */
    this.configuredThemes = [];

    /**
     * contains all default themes for workspaces
     * @type {Array}
     */
    this.defaultThemes = [];

    /**
     * contains all custom themes used for themes worlds etc.
     * @type {Array}
     */
    this.customThemes = [];

    this.format = {};
    this.tinymceOptions = {
        skin: 'lightgray',
        plugins: ['advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview', 'anchor', 'pagebreak',
            'searchreplace', 'wordcount', 'visualblocks', 'visualchars', 'code', 'fullscreen',
            'insertdatetime', 'media', 'nonbreaking', 'save', 'table', 'directionality',
            'emoticons', 'codesample'],
        toolbar1: 'undo redo | insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
        toolbar2: 'preview media | forecolor backcolor emoticons | codesample'
    };

    this.getIconClass = function (workspace) {
        if (workspace) {
            switch (workspace) {
                case 'shop':
                    return 'mdi-cart';
                case 'content':
                    return 'mdi-cards';
                case 'monitor':
                    return 'mdi-chart-line';
                case 'admin':
                    return 'mdi-cog';
                case 'system':
                    return 'mdi-database';
            }
        }
        return '';
    };

    this.setDateFormat = function (format) {
        this.format.dateformat = format.toUpperCase();
    };

    this.getDateFormat = function () {
        return this.format.dateformat;
    };

    this.$get = function () {
        var name = this.sourceURL;
        return {
            searchInput: this.searchInput,
            getIconClass: this.getIconClass,
            configuredThemes: this.configuredThemes,
            defaultThemes: this.defaultThemes,
            customThemes: this.customThemes,
            format: this.format,
            setDateFormat: this.setDateFormat,
            getDateFormat: this.getDateFormat,
            sourceURL: name,
            callback: 'VEENION_CALLBACK',
            useSecureCookie: this.useSecureCookie,
            tinymceOptions: this.tinymceOptions,
            baseURL: this.baseURL
        };
    };
});